import styled from "styled-components";

const FilterBody = styled.div`
    > .inner {
        padding: 15px;
        background: #f8f8f8;
        min-height: 100px;
        max-height: 250px;
        overflow: auto;
    }

    .filter-item {
        label {
            > input {
                height: 18px;
                width: 18px;
                margin-top: 2px;
            }
        }
    }

    .search-form {
        .form-control {
            padding-left: 35px;
            background: #f8f8f8;
            &:focus {
                box-shadow: none;
                border-color: #333;
            }
        }
        .icon {
            top: 6px;
            left: 10px;
            font-size: 16px;
        }
    }

    .price-filter-sec {
        input {
            height: 30px;
            background: #f8f8f8;
            &:focus {
                box-shadow: none;
                border-color: #333;
            }
        }
    }
`;

export default FilterBody;
